import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin } from 'antd';
import { Route, Switch, Link } from 'react-router-dom';

import Create from './LeadCreate';
import Open from './OpenLeads';

import LeadIcon from '../../components/Icons/LeadIcon';
import BizButton from '../../components/UI/BizIconButton';

import QUERY from '../../graphql/queries/allLeadsQuery.graphql';

const LeadIndex = (props) => {
  const { loading } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  const { path, url } = props.match;
  const { leads } = props.data;
  return (
    <div className="container-fluid" style={{ paddingTop: 20 }}>
      <div className="row">
        <div className="col-auto">
          <Link to={`${url}/create`}>
            <BizButton title="Create new lead" theme="lac"><LeadIcon type="new" fontSize={22} color="#FFFFFF" /></BizButton>
          </Link>
        </div>
        <div className="col-auto">
          <Link to={url}>
            <BizButton title="Open leads" theme="lac"><LeadIcon type="open" fontSize={22} color="#FFFFFF" /></BizButton>
          </Link>
        </div>
        <div className="col-auto">
          <Link to={`${url}/accepted`}>
            <BizButton title="Accepted leads" theme="lac"><LeadIcon type="accepted" fontSize={22} color="#FFFFFF" /></BizButton>
          </Link>
        </div>
        <div className="col-auto">
          <Link to={`${url}/rejected`}>
            <BizButton title="Rejected leads" theme="lac"><LeadIcon type="rejected" fontSize={22} color="#FFFFFF" /></BizButton>
          </Link>
        </div>
      </div>
      <Switch>
        <Route exact path={path} render={(renderProps) => (<Open {...renderProps} leads={leads.filter((lead) => (!lead.statusLogsList.includes('lead-rejected') && !lead.statusLogsList.includes('lead-accepted')))} />)} />
        <Route path={`${path}/create`} component={Create} />
      </Switch>
    </div>
  );
};

LeadIndex.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    leads: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })),
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default graphql(QUERY)(LeadIndex);



// WEBPACK FOOTER //
// ./src/pages/leads/LeadsIndex.jsx